import React, { useRef, useEffect } from 'react';
import { Field, FieldAttributes } from 'formik';

const FieldAuto: React.FC<FieldAttributes<any>> = (props) => {
  const fieldRef = useRef<HTMLInputElement>(null);

  /**
   * @description 根據初始的內容寬度設置 Field 寬度
   */
  useEffect(() => {
    if (fieldRef && fieldRef.current) {
      handleFieldWidthAuto(fieldRef, fieldRef.current.value.length);
    }
  }, [fieldRef]);

  /**
   * @description 根據內容寬度設置 Field 寬度
   */
  const handleFieldWidthAuto = (fieldRef: React.RefObject<HTMLInputElement>, fieldValueLength: number) => {
    if (fieldRef && fieldRef.current) {
      fieldRef.current.style.width = `calc(${fieldValueLength}ch + 22px)`;
    }
  };

  return (
    <Field {...props} innerRef={fieldRef} onInput={(event: React.ChangeEvent<HTMLInputElement>) => handleFieldWidthAuto(fieldRef, event.target.value.length)} />
  );
};

export default FieldAuto;
